import axios from 'axios';

const loadItems = (options, obj) => {
  return axios.get('/timesheet/reports/', {
    params: obj,
  }).then(response => {
    options.commit('SET_ITEMS', response.data);
    return response.data
  });
};

const getContractTimesheetInfo = (context, obj) => {
  // No need for FormData if you're sending GET request parameters
  return axios.get(`/timesheet/reports/contract_info/${obj.pk}/`, {
    params: obj
  })
  .then(response => {
    return response.data; // Return the response to be used in the component's promise chain
  })
};

// const addItem = (options, obj) => {
//   let bodyFormData = new FormData();
//   bodyFormData.append('obj', JSON.stringify(obj));
//   axios.post('/timesheet/add/', bodyFormData).then(response => {
//     options.commit('ADD_ITEM', response.data);
//   });
// };

// const editItem = (options, obj) => {
//   let bodyFormData = new FormData();
//   bodyFormData.append('obj', JSON.stringify(obj));
//   axios
//     .post('/timesheet/' + obj.pk + '/edit/', bodyFormData)
//     .then(response => {
//       options.commit('EDIT_ITEM', response.data);
//     });
// };

// const deleteItem = (options, obj) => {
//   axios.post('/timesheet/' + obj.pk + '/delete/').then(() => {
//     options.commit('DELETE_ITEM', obj);
//   });
// };

// export default { loadItems, addItem, editItem, deleteItem };
export default { loadItems, getContractTimesheetInfo };
